import { object, number, InferOutput } from 'valibot'

export const HasXYSchema = object({
  x: number(),
  y: number(),
})

export type HasXY = InferOutput<typeof HasXYSchema>
